export enum KnmWebNotificationStatusesEnum {
  CREATE = 'CREATE',
  REGISTERED = 'REGISTERED',
  WAITING_FOR_APPROVE = 'WAITING_FOR_APPROVE',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REVIEWED_WITH_COMMENTS = 'REVIEWED_WITH_COMMENTS',
}
